import styled from 'styled-components';
import { Spacing } from '~/src/atomic/obj.constants';
import { Grid } from '~/src/atomic/obj.grid';

export const FlashMessageWrapperStyled = styled(Grid)`
  position: fixed;
  right: 0;
  bottom: ${Spacing.Medium};
  left: 0;
`;
